var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"growth-stage"},[_vm._m(0),_c('div',{staticClass:"growth-stage-wrapper"},_vm._l((_vm.maxStage),function(s,sI){return _c('div',{key:'_s' + s,staticClass:"growth-stage-box",class:sI <= _vm.stage ? 'filled' : 'empty'})}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"growth-stage-connect"},[_c('div',{staticClass:"divider"})])
}]

export { render, staticRenderFns }